import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/Button";
import NoFoundImg from "assets/images/notFound.png";
import {Container} from "./styles";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Container>
      <img src={NoFoundImg} alt="" />
      <Button
        onClick={() => navigate(-1)}
      >
        Go Back
      </Button>
    </Container>
  );
}
